<template>
  <div
    :class="[
      'bbp-time-picker',
      isDateTimePicker && 'bbp-time-picker_date',
      isLeft && 'bbp-time-picker_left',
      isError && 'bbp-time-picker_error',
    ]"
  >
    <VueTimepicker
      v-model="timeValueDef"
      hideClearButton
      :inputWidth="`${inputWidth}px`"
      format="hh:mm A"
      manual-input
      :hide-dropdown="hideDropdown"
    />
  </div>
</template>

<script>

import VueTimepicker from 'vue2-timepicker/src/vue-timepicker.vue'

export default {
  name: 'BBPTimePicker',
  components: {
    VueTimepicker
  },
  props: {
    isDateTimePicker: {
      type: Boolean,
      default: false
    },
    isLeft: {
      type: Boolean,
      default: false
    },
    timeValue: {
      type: String,
      default: ''
    },
    defaultValue: {
      type: String,
      default: ''
    },
    inputWidth: {
      type: String,
      default: '78'
    },
    isError: {
      type: Boolean,
      default: false
    },
    hideDropdown: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    timeValueDef: {
      get () {
        return this.timeValue || this.defaultValue
      },
      set (data) {
        this.$emit('update:model', data)
      }
    }
  },
  watch: {
    timeValueDef () {
      this.$emit('update:isError', false)
    }
  }
}
</script>

<style lang="scss">
@import "../../../sass/variables";

.bbp-time-picker {
  height: 100%;
  position: relative;

  ::-webkit-scrollbar {
    width: 4px;
    background-color: $color-white;
  }

  ::-webkit-scrollbar-thumb {
    background-color: $color-denim;
    border-radius: 9em;
    height: 50px;
  }

  ::-webkit-scrollbar-thumb:hover {
    background-color: $color-denim;
  }

  scrollbar-color: $color-denim $color-white;
  scrollbar-width: thin;

  .hint {
    display: none;
  }

  .active {
    background: $color-white !important;
    color: $color-denim !important;
  }

  .dropdown {
    border-top-right-radius: 5px;
    border-top-left-radius: 5px;
    top: calc(2.2em + 5px) !important;
    height: 140px !important;
    width: 118px !important;
  }

  .select-list {
    height: 140px !important;
    width: 118px !important;
  }

  .vue__time-picker {
    height: 100%;

    .char {
      color: $color-denim;
    }
  }

  .apms {
    display: flex;
    width: 100%;
    padding: 9px !important;
    background: $color-white;
    position: absolute;
    top: 140px;
    box-shadow: 0 1px 6px rgba(0, 0, 0, .15);
    border-bottom-right-radius: 5px;
    border-bottom-left-radius: 5px;

    .active {
      background: $color-denim !important;
      color: $color-white !important;

      &:hover {
        background: $color-denim !important;
      }
    }

    .hint {
      display: none;
    }

    li {
      width: 100%;
      padding: 3px 0 3px 0 !important;
      border-color: $color-mercury;
      border-style: solid;
      border-top-width: 1px;
      border-bottom-width: 1px;
      border-left-width: 1px;
      border-bottom-left-radius: 6px;
      border-top-left-radius: 6px;

      &:hover {
        background: none !important;
      }

      &:last-child {
        border-bottom-left-radius: 0;
        border-bottom-right-radius: 6px;
        border-top-left-radius: 0;
        border-top-right-radius: 6px;
        border-right-width: 1px;
      }
    }
  }

  .time-picker input {
    width: 78px !important;
    padding: 6px 8px 6px 8px !important;
    height: 30px !important;
    border-radius: 5px;
    border: 1px solid $color-mercury !important;
    font-size: 14px !important;
    line-height: 17px;
    color: $color-black;
  }

  &_date {
    border-left: 1px solid #E6E6E6;

    .vue__time-picker input.display-time {
      border: none;
      border-top-left-radius: 0;
      border-bottom-left-radius: 0;
    }
  }

  &_left {
    .dropdown {
      left: -33px !important;
    }
  }

  &_error {
    .time-picker input {
      border-color: $color-pomegranate !important;
    }
  }
}

</style>



// WEBPACK FOOTER //
// src/components/Main/BBPTimePicker/BBPTimePicker.vue